/**
 * A Skeleton component that displays a gray loading bar with a pulsing animation.
 *
 * @param {Object} props - Component props.
 * @param {string} [props.className=""] - Additional Tailwind CSS classes.
 * @return {JSX.Element} - The rendered Skeleton component.
 */
const Skeleton = ({ className = '' }) => {
  return (
    <div
      className={`animate-pulse bg-gray-300 ${className}`}
    />
  );
};

export default Skeleton;
